/*
  Spring Reset announcement bar: GA4 events.

  Events (sent only to the GA4 property, not the Ads / other Google tags):
    src_bar_view     bar was visible on this page view
    src_bar_click    bar link clicked
    src_bar_dismiss  close button clicked
  Params on every event: site_market, page_type.

  The copy A/B test (src_bar_copy_v1) ended 2026-10-21 with the control copy as
  the winner, so the split, the variant and the arm params are gone. Visitors
  still carrying the old `src_bar_ab` cookie or cart attribute are cleaned up
  once below, otherwise those orders would keep reporting a variant arm after
  the test has finished.
*/
(function () {
  var bar = document.querySelector('[data-src-bar]');
  if (!bar) return;

  var GA4 = 'G-Y0VT2QGQW7';
  var LEGACY_COOKIE = 'src_bar_ab';
  var LEGACY_STORAGE = 'src_bar_ab';
  var CLEANUP_KEY = 'src_bar_ab_cleanup';

  window.dataLayer = window.dataLayer || [];
  function gtagCall() {
    if (typeof window.gtag === 'function') {
      window.gtag.apply(window, arguments);
    } else {
      window.dataLayer.push(arguments);
    }
  }

  function send(name, extra) {
    var params = {
      send_to: GA4,
      site_market: bar.getAttribute('data-market') || '',
      page_type: bar.getAttribute('data-page-type') || ''
    };
    if (extra) {
      for (var key in extra) params[key] = extra[key];
    }
    gtagCall('event', name, params);
  }

  /* Wind-down for the finished copy test: expire the arm cookie, drop the
     localStorage backup, and clear the arm off the cart so new orders stop
     carrying a variant that no longer means anything. Once per session. */
  function cleanupLegacyArm() {
    try {
      if (sessionStorage.getItem(CLEANUP_KEY) === '1') return;
      sessionStorage.setItem(CLEANUP_KEY, '1');
    } catch (e) {}

    try {
      var domain = /(^|\.)fitazfk\.com$/.test(window.location.hostname) ? ';domain=.fitazfk.com' : '';
      /* Expire both forms: the split wrote a host-only cookie on subdomains and a
         .fitazfk.com cookie on the primary domain, and a domain-scoped expiry
         does not remove a host-only cookie (or vice versa). */
      document.cookie = LEGACY_COOKIE + '=;path=/;max-age=0';
      document.cookie = LEGACY_COOKIE + '=;path=/;max-age=0' + domain;
    } catch (e) {}
    try {
      localStorage.removeItem(LEGACY_STORAGE);
    } catch (e) {}

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.attributes) return null;
        if (!Object.prototype.hasOwnProperty.call(cart.attributes, LEGACY_COOKIE)) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { src_bar_ab: '' } })
        });
      })
      .catch(function () {});
  }

  cleanupLegacyArm();

  if (!bar.hidden) send('src_bar_view');

  var link = bar.querySelector('.src-bar__link');
  if (link) {
    link.addEventListener('click', function () {
      send('src_bar_click', { link_url: link.getAttribute('href') || '', transport_type: 'beacon' });
    });
  }

  var close = bar.querySelector('[data-src-bar-close]');
  if (close) {
    close.addEventListener('click', function () {
      send('src_bar_dismiss', { transport_type: 'beacon' });
    });
  }
})();
